module.exports = __webpack_public_path__ + "static/fonts/iconfont.6426d278.woff2";